import { styled } from "styled-components";

import { Draggable } from "components/lib/dnd/Draggable";
import { Droppable } from "components/lib/dnd/Droppable";

import { ILaneData } from ".";

export const LaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 300px;
  width: 300px;
  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  max-height: 100%;
  padding: 4px;

  .lane-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;

    overflow: auto;
    padding: 4px;

    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 5px;
      background: rgb(230, 231, 233);
    }
  }

  border-radius: 5px;
  background: rgb(241, 242, 244);
  box-shadow:
    rgba(9, 30, 66, 0.25) 0px 1px 1px 0px,
    rgba(9, 30, 66, 0.31) 0px 0px 1px 0px;
`;

const CardWrapper = styled.div`
  cursor: pointer;
  z-index: 1;
`;

type ProjectLaneProps = {
  lane: ILaneData;
  renderLaneHeader?: (lane: ILaneData) => React.ReactNode;
  renderCard: (card: ILaneData["cards"][0]) => React.ReactNode;
};

export const ProjectLane = ({
  lane,
  renderLaneHeader,
  renderCard,
}: ProjectLaneProps) => {
  return (
    <Draggable
      disabled={lane.draggingDisabled}
      key={lane.id}
      id={`lane-${lane.id}`}
      style={{ height: "100%" }}
    >
      <LaneWrapper>
        {renderLaneHeader ? renderLaneHeader(lane) : null}

        <Droppable
          id={`lane-${lane.id}`}
          direction="vertical"
          itemIds={lane.cards.map((card) => `card-${card.id}`)}
          emptyAreaStyle={{ height: 100 }}
        >
          <div className="lane-content">
            {lane.cards.map((card) => (
              <Draggable
                key={card.id}
                id={`card-${card.id}`}
                disabled={card.draggingDisabled}
              >
                <CardWrapper>{renderCard(card)}</CardWrapper>
              </Draggable>
            ))}
          </div>
        </Droppable>
      </LaneWrapper>
    </Draggable>
  );
};
